import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { UserState } from './shared-constants';
import { EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class UserService {
	constructor(
		private db: SpaqFireDb,
		private auth: AngularFireAuth
	) {}

	delete() {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => u.delete())
		);
	}

	hydrate() {
		return this.auth.user.pipe(switchMap(u => (u ? this.db.user$<UserState>(u.uid) : EMPTY)));
	}
}
